// Cart drawer upsell: free-shipping progress bar and the "Add" button.
//
// Must stay an asset loaded unconditionally from cart-drawer.liquid. Inline in
// cart-upsell.liquid it only shipped in the drawer's non-empty branch, so a
// shopper arriving with an empty cart never ran it -- and the markup morphed in
// later carries a <script> the browser will not execute, leaving the Add button
// with no listener. Everything here no-ops when the markup is absent.
//
// @theme/events is a build-time alias, imported dynamically so a failed
// resolution can't abort the module.

async function updateUpsellSection() {
  const wrapper = document.querySelector("#cd-upsell-wrapper");
  if (!wrapper) return;

  const allProducts = Array.from(wrapper.querySelectorAll(".cd-upsell-product"));
  if (allProducts.length === 0) return;

  let cart;
  try {
    cart = await fetch("/cart.js").then((r) => r.json());
  } catch {
    return; // keep whatever is currently visible
  }

  const freeAmount = Number(wrapper.dataset.freeAmount);
  const cartTotal = cart.total_price;
  const left = Math.max(freeAmount - cartTotal, 0);
  const cartProductIds = new Set(cart.items.map((i) => String(i.product_id)));

  if (left === 0) {
    wrapper.setAttribute("data-shipping-free", "");
  } else {
    wrapper.removeAttribute("data-shipping-free");
    const leftEl = wrapper.querySelector("#cd-upsell-left");
    if (leftEl) leftEl.textContent = `$${(left / 100).toFixed(2)}`;
  }
  const barFill = wrapper.querySelector(".cd-upsell-bar-fill");
  if (barFill) barFill.style.width = `${Math.min((cartTotal / freeAmount) * 100, 100)}%`;

  // One product always shown, preferring those not already in the cart.
  const eligible = allProducts.filter((p) => {
    const pid = p.dataset.productId;
    return !pid || !cartProductIds.has(pid);
  });
  const pool = eligible.length > 0 ? eligible : allProducts;

  allProducts.forEach((p) => p.classList.remove("is-visible"));
  pool[Math.floor(Math.random() * pool.length)].classList.add("is-visible");
}

// Module scripts are deferred, so the DOM is ready here.
updateUpsellSection();

document.addEventListener("cart-drawer:open", updateUpsellSection);
document.addEventListener("cart:update", updateUpsellSection);

// Delegated so it survives section morphs.
document.addEventListener("click", async (e) => {
  const btn = e.target.closest(".cd-upsell-btn");
  if (!btn) return;

  btn.disabled = true;
  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: btn.dataset.variant, quantity: 1 }),
    });

    const { CartUpdateEvent } = await import("@theme/events").catch(() => ({}));
    const cartRes = await fetch("/cart.js");
    const cart = await cartRes.json();

    if (CartUpdateEvent) {
      document.dispatchEvent(
        new CartUpdateEvent(cart, "", {
          itemCount: cart.item_count,
          source: "cart-items-component",
        })
      );
    }

    updateUpsellSection();
  } finally {
    btn.disabled = false;
  }
});
